import React from "react";
import BahutBadhiya from "../../../../assets/svgs/gameplay/BahutBadhiya";
import { getWidth } from "../../../../utils/relativeSizes";
import CommonAnimation from "./CommonAnimation";

const BahutBadhiyaAnimation = () => {

  return (
    <CommonAnimation>
      <BahutBadhiya width={getWidth(97)} height={getWidth(81)} />
    </CommonAnimation>
  );
};

export default BahutBadhiyaAnimation;
